export enum UserRole {
  User = '87654321-1234-5678-abcd-0987654321ab',
  Organisational_Administrator = '149d30ce-3dad-40e1-9d6a-31f0fa5e6fee',
  Administrator = 'ac7085d9-2707-4e37-b010-ebc08c18337b',
  Super_Admin = '634757ae-3692-4090-a782-a0fe2b925f20',
}